import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import RecipeSummary from '../../components/RecipeSummary';

import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import CheckIcon from '@mui/icons-material/Check';
import RemoveIcon from '@mui/icons-material/Remove';

import ImageCard from '../../components/ImageCard';
import Loader from '../../components/Loader';
import API from '../../api';
import { updateRetailer } from '../../actions/Retailer';
import { getTranslation } from '../../utils/translate';
import LinkToCreate from '../../components/LinkToCreate';
import { Link } from 'react-router-dom';
import { updateVideos } from '../../actions/VideosAction';

const Videos = () => {
  const retailer = useSelector(state => state.retailer);
  const videos = useSelector(state => state.videos.data);

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const summaryValues = [
    {
      label: 'Total',
      value: 0
    },
    {
      label: 'New',
      value: 0,
    },
    {
      label: 'Collected',
      value: retailer?.beef_products?.filter(beefProduct => beefProduct.beef_product_id).length // filter out null values
    },
  ];

  const makeGetVideosRequest = async () => {
    return await API.getVideos({
      filter: {}
    });
  };

  const addBeefCuteToLibray = async (beefCutId) => {
    try {
      setLoading(true);

      // get retailer details
      // TODO consider using retailer end point with 
      const userResponse = await API.getUserAndRetailer();

      // save retailer state
      let retailer = userResponse.retailer;
      dispatch(updateRetailer(retailer));

      // get list of recipes
      const payload = {
        beef_products: retailer.beef_products
      }

      // append
      payload.beef_products.push({
        beef_product_id: beefCutId
      });

      // make PATCH request
      retailer = await makeRetailerPatchRequest(payload);
      dispatch(updateRetailer(retailer));

      // get new list of beef cuts
      // TODO consider refactoring this function
      await fetchVideos();
    } catch (error) {
      console.log('error: ', error);
    } finally {
      setLoading(false);
    }
  }

  const removeBeefCutFromLibrary = async (beefCutId) => {
    try {
      setLoading(true);

      // get retailer details
      // TODO consider using retailer end point with 
      const userResponse = await API.getUserAndRetailer();

      // save retailer state
      let retailer = userResponse.retailer;
      dispatch(updateRetailer(retailer));

      // get list of recipes
      const payload = {
        beef_products: retailer.beef_products.filter(beefProduct => beefProduct.beef_product_id !== beefCutId)
      }

      // make PATCH request
      retailer = await makeRetailerPatchRequest(payload);
      dispatch(updateRetailer(retailer));

      // get new list of beef cuts
      // TODO consider refactoring this function
      await fetchVideos();
    } catch (error) {
      console.log('error: ', error);
    } finally {
      setLoading(false);
    }
  }

  const makeRetailerPatchRequest = async (payload) => {
    return await API.updateRetailer(payload);
  }

  useEffect(() => {
    fetchVideos();
  }, []);

  const fetchVideos = async () => {
    try {
      const videosResponse = await makeGetVideosRequest();

      dispatch(
        updateVideos(videosResponse)
      );
    } catch (error) {
      console.log('error: ', error);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <Box sx={{ flexGrow: 1, my: 3 }}>
      <Typography className='form-title' variant="h2">Videos</Typography>

      <RecipeSummary summaryValues={summaryValues} />

      <Grid sx={{ mt: 4 }} container spacing={2}>
        <Grid item xs={6} md={3} lg={2}>
          <LinkToCreate />
        </Grid>
        {videos?.map((video) => (
          <Grid key={video.id} item xs={6} md={3} lg={2}>
            <Link to={`/videos/${video.id}`}>
              <ImageCard
                item={{
                  title: getTranslation(video, { key: 'languages_id', code: 'en-US' }, 'translations')?.name || ' ',
                  url: video.image ? `${process.env.REACT_APP_API_URL}/assets/${video.image}?key=system-medium-cover` : ''
                }}
                footerAction={!!video?.retailers?.filter(retailerJunction => retailerJunction.retailer_id === retailer.id).length ?
                  <IconButton
                    variant="contained"
                    onClick={() => { removeBeefCutFromLibrary(video.id) }}
                    sx={{
                      background: '#3B8234',
                      color: 'white',
                      '&:hover': {
                        color: '#3B8234',
                      },
                    }}
                  >
                    <CheckIcon />
                  </IconButton> :
                  <IconButton
                    onClick={() => { addBeefCuteToLibray(video.id) }}
                    variant="contained"
                    sx={{
                      background: '#932525',
                      color: 'white',
                      '&:hover': {
                        color: '#932525',
                      },
                    }}
                  >
                    <RemoveIcon />
                  </IconButton>
                }
              />
            </Link>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default Videos